import { Availability } from './availability';
import { PriceChange } from './price-change';
import { ProductType } from './product-type';
import { TranslatedText, Translation } from './translated-text';

export class Product {
  id: string;
  productId: string;
  sku: string;
  name: string | TranslatedText;
  description: string | TranslatedText;
  price: number;
  priceChanges: PriceChange[];
  order: any;
  energyInformation: string;
  originalImageUrl: string;
  isVisible: boolean;
  tags: any[];
  categoryIds: string[];
  isAvailable: boolean;
  availability: Availability[];
  allergens: string[];
  type: ProductType;
  lastUpdated: Date;
  imageUrl: string;
  currentImageUrlHash: string;
  providerData: any;
  posItemId: number;
  serves: string | TranslatedText;

  constructor(
    id: string,
    sku: string,
    name: string | TranslatedText,
    description: string | TranslatedText,
    price: number,
    priceChanges: PriceChange[],
    order: any,
    energyInformation: string,
    imageUrl: string,
    isVisible = true,
    categoryId: string,
    isAvailable = true,
    originalImageUrl: string,
    posItemId: number,
    nameTranslations?: Translation[],
    serves?: string | TranslatedText,
  ) {
    this.id = id;
    this.productId = id;
    this.sku = sku;
    this.name = typeof name === "string" ? new TranslatedText(name) : name || new TranslatedText('');
    this.description = typeof description === "string" ? new TranslatedText(description) : description || new TranslatedText('');
    this.price = price;
    this.priceChanges = priceChanges;
    this.order = order;
    this.energyInformation = energyInformation;
    this.originalImageUrl = originalImageUrl || imageUrl;
    this.isVisible = isVisible;
    this.tags = [];
    this.categoryIds = categoryId ? [categoryId] : [];
    this.isAvailable = isAvailable;

    this.serves = typeof serves === "string" ? new TranslatedText(serves) : serves || new TranslatedText('');

    // Date and time fields for product availability
    this.availability = [new Availability()];
    this.allergens = [];
    this.type = ProductType.SIMPLE;
    this.lastUpdated = new Date();

    // Auxiliary fields for the image function
    this.imageUrl = '';
    this.currentImageUrlHash = '';
    this.providerData = {};

    this.posItemId = posItemId;

    if (this.name) {
      nameTranslations?.forEach(
        translation =>
          translation && (this.name as TranslatedText)?.addTranslation(translation.language, translation.text),
      );
    }
  }

  setOrder(order: number, categoryId: string) {
    if ((order === 0 || order) && categoryId) {
      this.order[categoryId] = order;
    }
  }

  toGenericObject() {
    return JSON.parse(JSON.stringify(this));
  }
}
